export const PDV_NOVO_V3_LOCALSTORAGE_KEY = 'promokit.pdv.novo-v3.habilitado';

export function leiaFlagPdvNovoV3Local(): boolean {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return false;
    const value = window.localStorage.getItem(PDV_NOVO_V3_LOCALSTORAGE_KEY);
    return value === '1' || value === 'true';
  } catch (e) {
    return false;
  }
}

export function salveFlagPdvNovoV3Local(habilitado: boolean): void {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.setItem(PDV_NOVO_V3_LOCALSTORAGE_KEY, habilitado ? '1' : '0');
  } catch (e) {
    // Ignora falhas de persistencia local (ex.: storage bloqueado pelo navegador).
  }
}
